// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vooaasxzrtflkljzuqpu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZvb2Fhc3h6cnRmbGtsanp1cXB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1NjAzMzksImV4cCI6MjA1MzEzNjMzOX0.DiEJKfMPnfzFRLL4fQFIpQuDv1ypaRfTcsbb1zgxe_k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

export { SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, supabase};